import type { FC, MouseEvent } from 'react';
import { useCallback, useEffect } from 'react';
import { Icon } from 'src/common/components/icon';
import { useOpenModal } from 'src/common/components/next-modal';
import { Modals } from 'src/modals';
import { PageScene, usePageScene } from 'src/views/main/scene-context';
import { TransferList } from '.';
import { useTransferStatus } from './hooks';
import { TransferStatus, transferStatusIcons } from './types';

export const TransferButton: FC<{}> = () => {
  const openModal = useOpenModal();
  const status = useTransferStatus();
  const pageScene = usePageScene();
  const hiddenBtn = status === TransferStatus.NONE || pageScene !== PageScene.MAIN;

  const closeModal = useCallback(() => openModal.closeModal(Modals.TRANSFER_LIST_ID), [openModal]);

  useEffect(() => {
    if (status === TransferStatus.NONE || hiddenBtn) {
      // 如果删掉最后一个item，需要设置回不展示列表
      closeModal();
    }
  }, [closeModal, hiddenBtn, status]);

  const handleOpen = (ev: MouseEvent) => {
    openModal.dropdown({
      popcorn: ev.currentTarget,
      modalId: Modals.TRANSFER_LIST_ID,
      offset: [0, 8],
      content: () => <TransferList onHide={() => closeModal()} />,
    });
  };

  if (hiddenBtn) return null;

  return (
    <div
      className="transition-all flex items-center justify-center select-none right-5 w-9 h-9 rounded-full animate-click opacity-100 next-modal shadow-light-sm"
      onClick={handleOpen}
    >
      <Icon
        className={status === TransferStatus.TRANSFERRING ? 'animate-spin' : ''}
        name={transferStatusIcons[status].name}
        style={{ color: transferStatusIcons[status].color }}
        size="small"
      />
    </div>
  );
};
